/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1TransactionEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_PORTFOLIO_V1_TRANSACTION_EVENT_ENTITY_NAME = 'ixc.portfolio.v1.TransactionEvent';
export const ixcPortfolioV1TransactionEventEntity = new schema.Entity<IxcPortfolioV1TransactionEvent>(IXC_PORTFOLIO_V1_TRANSACTION_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        posted: new schema.Object({
            assets: [new schema.Object({
                    asset: ixcAssetsV1AssetStateEntity
                })]
        })
    })
}, { idAttribute: (entity: IxcPortfolioV1TransactionEvent) => `${entity.metadata?.eventId}` });

